<dx-data-grid [dataSource]="dataSource"
              [showBorders]="true"
              [columns]="columns"
              [columnAutoWidth]="true">
  <dxo-editing mode="batch"
               [allowDeleting]="true"
               [allowUpdating]="true"></dxo-editing>
  <div *dxTemplate="let data of 'menuItemsTemplate'">
    {{data.value | json}}
  </div>
</dx-data-grid>
